import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function LanguageToggle() {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const newLang = i18n.language === 'en' ? 'es' : 'en';
    i18n.changeLanguage(newLang);
    localStorage.setItem('language', newLang);
  };

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={toggleLanguage}
      title={i18n.language === 'en' ? 'Español' : 'English'}
      className="gap-2 w-14"
    >
      <Globe className="h-4 w-4" />
      <span className="text-sm">{i18n.language.toUpperCase()}</span>
    </Button>
  );
}
